/* Version: 3.5.149 */
'use client';
import styled from 'styled-components';
import { typography } from '../../typography/typography.js';

var LegendWrapper = /*#__PURE__*/styled.legend.withConfig({
  displayName: "styledComponents__LegendWrapper",
  componentId: "sc-143ilfq-0"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";display:block;margin-bottom:5px;& .mux-Legend-Tooltip{margin-left:6px;}", ""], typography.fontFamily, typography.fontSize, typography.lineHeight, typography.fontWeightDemibold, function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref2) {
  var legendStyle = _ref2.legendStyle;
  return legendStyle;
});
process.env.NODE_ENV !== "production" ? LegendWrapper.displayName = 'LegendWrapper' : undefined;

export { LegendWrapper, LegendWrapper as default };
